import videojs from "video.js";
import forwardIcon from "../../../assets/images/player/forward.svg"
class ForwardButtonOverlay extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-skip-forward-overlay custom-control');

        // Add button click listener
        this.on('click', () => {
            player.currentTime(player.currentTime() + 10); // Skip forward 10 seconds
        });
    }

    createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-skip-forward-overlay custom-control',
            innerHTML: `<img src="${forwardIcon}"/>`
        });
    }
}

videojs.registerComponent('ForwardButtonOverlay', ForwardButtonOverlay);